export const GET_TEMPLATE_DETAIL_REQUEST = 'GET_TEMPLATE_DETAIL_REQUEST';
export const GET_TEMPLATE_DETAIL_SUCCESS = 'GET_TEMPLATE_DETAIL_SUCCESS';
export const GET_TEMPLATE_DETAIL_FAIL = 'GET_TEMPLATE_DETAIL_FAIL';
export const RESET_TEMPLATE_DETAIL = 'RESET_TEMPLATE_DETAIL';
